module.exports = __webpack_public_path__ + "img/footerCode.bfcc0c0e.jpg";